import React from 'react';
import { CatalogsContext } from './CatalogsContext';
import useCatalogs from 'src/hooks/useCatalogs';
import useCatalogKinds from 'src/hooks/useCatalogKinds';

const CatalogsProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const catalogsData = useCatalogs();
	const catalogKindsData = useCatalogKinds();

	return (
		<CatalogsContext.Provider
			value={{
				...catalogsData,
				...catalogKindsData,
				refetch: catalogsData.refetch,
			}}
		>
			{children}
		</CatalogsContext.Provider>
	);
};

export default CatalogsProvider;
